import baseTheme from '../../../theme/depi';

const theme = Object.assign({}, baseTheme);

theme.overrides = {
  MuiTypography: {
    // title block
    h1: {
      textAlign: 'center',
      fontSize: 48,
      lineHeight: 1.2,
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(8),
      '&:after': {
        content: '""',
        backgroundColor: theme.editorPalette.primary.main,
        height: 2,
        width: 100,
        position: 'absolute',
        left: '50%',
        bottom: theme.spacing(-2),
        transform: 'translate(-50%,0)',
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: 38,
        lineHeight: 1.1875,
      },
    },
    // h1 block
    h2: {
      textAlign: 'center',
      fontSize: 32,
      lineHeight: 1.25,
      marginTop: theme.spacing(12),
      marginBottom: theme.spacing(4),
    },
    // h2 block
    h4: {
      textAlign: 'center',
      color: theme.editorPalette.primary.main,
      fontSize: 24,
      lineHeight: 1.33,
      marginTop: 0,
      marginBottom: theme.spacing(5),
    },
    // normal text block
    h6: {
      fontSize: 21,
      lineHeight: 1.5238095238,
      marginBottom: theme.spacing(6),
      [theme.breakpoints.only('xs')]: {
        fontSize: 18,
        lineHeight: 1.3888888889,
      },
    },
    // website block
    // address block
    // phone block
    // email block
    body1: {
      marginBottom: theme.spacing(1),
      '&.email': {
        marginBottom: theme.spacing(6),
      },
    },
    // caption block
    caption: {
      marginBottom: theme.spacing(1),
    },
  },
};

export default theme;
